module.exports = __webpack_public_path__ + "img/RB_Gladius.39cac7e1.png";